import React from 'react';
import { useNavigate } from 'react-router-dom';
import './FooterHome.css';
import HorarioFuncionamento from '../../../../components/HorarioFuncionamento';

// Assets
import logoIti from '../../assets/logo_iti.png';
import logoicp from '../../assets/logo_icp.png';
import uen from '../../../../assets/uenlogo.png';
import cie from '../../assets/cie.png';
import instaicon from '../../assets/instaicon.png';
import phoneicon from '../../assets/phoneicon.png';
import zapicon from '../../assets/zapicon.png';

const FooterHome = () => {
  const navigate = useNavigate();
  const phoneNumber = "31997333998";

  const openWhatsApp = () => {
    window.open(`https://wa.me/${phoneNumber}`, "_blank");
  };

  return (
    <footer className="footer-modern-wrapper">
      <div className="footer-gradient-overlay" />
      
      <div className="footer-content-container">
        
        {/* PARTE SUPERIOR: VALIDADE & BRANDING MISTURADOS */}
        <div className="footer-top-row">
          <div className="footer-brand-info">
            <img src={uen} alt="UEN" className="main-logo-glow" />
            <p className="brand-description">
              UEN Estudantil: Garantindo o seu direito à meia-entrada com 
              tecnologia de ponta.
            </p>
          </div>

          <div className="footer-legal-card">
            <h4>Validade Garantida</h4>
            <p>Em conformidade com a <strong>Lei 12.933/13</strong>.</p>
            <div className="legal-badges">
              <img src={logoIti} alt="ITI" width={150} />
              <img src={logoicp} alt="ICP" width={100} />
              <img src={cie} alt="CIE" className="cie-small" width={170} />
            </div>
          </div>
        </div>

        <div className="footer-divider-glass" />

        {/* PARTE CENTRAL: LINKS E CONTATO */}
        <div className="footer-main-grid">
          <div className="footer-column">
            <span className="column-title">Navegação</span>
            <nav className="footer-links-list">
              <button onClick={() => navigate("/")}>Início</button>
              <button onClick={() => navigate("/politicadeprivacidade")}>Privacidade</button>
              <button onClick={() => navigate("/termosdeuso")}>Termos de Uso</button>
            </nav>
          </div>

          <div className="footer-column center-align">
            <span className="column-title">Suporte e Contato</span>
            <div className="social-pill-container">
              <div className="social-pill" onClick={() => window.open("https://www.instagram.com/carteirinhauenoficial", "_blank")}>
                <img src={instaicon} alt="Instagram" />
                <span>@uenoficial</span>
              </div>
              <div className="social-pill" onClick={openWhatsApp}>
                <img src={zapicon} alt="WhatsApp" />
                <span>WhatsApp</span>
              </div>
            </div>
          </div>

          <div className="footer-column">
             <span className="column-title">Certificação Digital</span>
             <p className="cert-text">Assinatura digital padrão ICP-Brasil com validação.</p>
          </div>

          <div className="footer-column right-align">
             <span className="column-title">Horário de Aprovação</span>
             <HorarioFuncionamento variant="footer" />
          </div>
        </div>

        {/* RODAPÉ FINAL */}
        <div className="footer-bottom-info">
          <p>Copyright 2026 © <strong>UEN</strong> — Todos os direitos reservados</p>
        </div>
      </div>
    </footer>
  );
};

export default FooterHome;